import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Switch from 'react-switch'
import Input from '../../../Core/Input/Input'
import InputSelect from '../../../Core/InputSelect'
import styles from './styles.module.scss'

const EmployeeTargetsForm = ({ employee, onChange }) => {
  const { t } = useTranslation()

  const handleSwitchChange = (field) => (checked) => {
    onChange(employee.id, {[field]: checked})
  }

  const handleInputChange = (field) => (event) => {
    const { value } = event.target
    onChange(employee.id, {[field]: value})
  }

  const handleSelectChange = (field) => (event) => {
    const { value } = event.target
    onChange(employee.id, {[field]: value})
  }

  const salesTargetPeriodOptions = [
    { value: 'daily', label: t('Daily') },
    { value: 'monthly', label: t('Monthly') }
  ]

  const bonusTypeOptions = [
    { value: 'fixed', label: t('Fixed') },
    { value: 'percent_from_sales', label: t('Percent from sales') },
    { value: 'percent_above_target', label: t('Percent above target') }
  ]

  return (
    <div className={styles.container}>
      <div className={styles.headerSection}>
        <h3 className={styles.title}>{employee.title}</h3>
        <div className={styles.switchGroup}>
          <span className={styles.switchLabel}>{t('Active')}</span>
          <Switch
            checked={employee.targets.active}
            onChange={handleSwitchChange('active')}
            offColor='#808F94'
            onColor='#0085FF'
            height={21}
            width={40}
            uncheckedIcon={false}
            checkedIcon={false}
          />
        </div>
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <h4 className={styles.sectionTitle}>{t('Sales target')}</h4>
          <Switch
            checked={employee.targets.sales_target}
            onChange={handleSwitchChange('sales_target')}
            offColor='#808F94'
            onColor='#0085FF'
            height={21}
            width={40}
            uncheckedIcon={false}
            checkedIcon={false}
          />
        </div>

        {employee.targets.sales_target && (
          <div className={styles.sectionContent}>
            <div className={styles.fieldsRow}>
              <div className={styles.fieldGroup}>
                <div className={styles.label}>{t('Period')}</div>
                <InputSelect
                  options={salesTargetPeriodOptions}
                  value={employee.targets.sales_target_type}
                  onChange={handleSelectChange('sales_target_type')}
                  placeholder={t('Select period')}
                  disabled
                />
              </div>
              <div className={styles.fieldGroup}>
                <label className={styles.label}>{t('Daily sales target')} (€)</label>
                <Input
                  type='number'
                  placeholder='0.00'
                  value={employee.targets.sales_target_amount}
                  onChange={handleInputChange('sales_target_amount')}
                  fullWidth
                />
              </div>
              {/* <div className={styles.fieldGroup}>
                <label className={styles.label}>{t('Monthly sales target')} (€)</label>
                <Input
                  type='number'
                  placeholder='0.00'
                  value={employee.targets.sales_target_monthly_amount}
                  onChange={handleInputChange('sales_target_monthly_amount')}
                  fullWidth
                />
              </div> */}
            </div>
          </div>
        )}
      </div>

      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <h4 className={styles.sectionTitle}>{t('Bonus')}</h4>
          <Switch
            checked={employee.targets.bonus}
            onChange={handleSwitchChange('bonus')}
            offColor='#808F94'
            onColor='#0085FF'
            height={21}
            width={40}
            uncheckedIcon={false}
            checkedIcon={false}
          />
        </div>

        {employee.targets.bonus && (
          <div className={styles.sectionContent}>
            <div className={styles.fieldsRowTwoColumn}>
              <div className={styles.fieldGroup}>
                <div className={styles.label}>{t('Bonus type')}</div>
                <InputSelect
                  options={bonusTypeOptions}
                  value={employee.targets.bonus_type}
                  onChange={handleSelectChange('bonus_type')}
                  placeholder={t('Select bonus type')}
                />
              </div>

              <div className={styles.fieldGroup}>
                <label className={styles.label}>{t('Bonus amount')}</label>
                <Input
                  type='number'
                  placeholder='0.00'
                  value={employee.targets.bonus_amount}
                  onChange={handleInputChange('bonus_amount')}
                  fullWidth
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default EmployeeTargetsForm
